<template>
  <v-card-text class="value-display" :style="containerStyle">
    <div class="value-display__value" :style="valueStyle">
      {{ displayValue }}
    </div>
  </v-card-text>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["widget"],

  computed: {
    widgetWidth() {
      return Number(this.widget?.size?.w) || 180;
    },

    widgetHeight() {
      return Number(this.widget?.size?.h) || 160;
    },

    contentHeight() {
      return Math.max(50, this.widgetHeight - 58);
    },

    scaleBase() {
      return Math.min(this.widgetWidth, this.contentHeight * 2.2);
    },

    fontSize() {
      return this.clamp(Math.round(this.scaleBase * 0.24), 24, 96);
    },

    displayValue() {
      const value = this.widget?.payload;
      return value !== undefined && value !== null && value !== "" ? value : "--";
    },

    containerStyle() {
      return {
        height: `${this.contentHeight}px`,
        padding: `${this.clamp(Math.round(this.scaleBase * 0.035), 6, 18)}px`,
      };
    },

    valueStyle() {
      return {
        fontSize: `${this.fontSize}px`,
        lineHeight: "1.05",
      };
    },
  },

  methods: {
    ...mapActions(["doPublish"]),

    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    },

    update() {},
  },

  mounted() {
    this.update();
    this.$store.watch(
      (state) => {
        return state.widgets.filter((d) => d.topic == this.widget.topic);
      },
      () => {
        this.update();
      },
      { deep: true }
    );
  },
};
</script>

<style scoped>
.value-display {
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: #111111;
  text-align: center;
}

.value-display__value {
  width: 100%;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
